import {parserMainClass} from "./mainParser";
import {Observable} from "rxjs";

export class gpxParserClass extends parserMainClass{
  constructor(file) {
    super(file);
  }

  public getData(){
    return new Observable((observer)=>{
      if (!this.isAllowedType()){
       observer.error('Wrong file type added! File type must be gpx');
       return;
      }
      let reader = new FileReader();
      reader.onload = (data:any)=>{
        let div = document.createElement('div');
        div.innerHTML = data.target.result;
        let trackList = div.querySelectorAll('trk');
        observer.next(trackList);
      };

      reader.onerror = (error)=>{
        observer.error('Error while reading file');
        return;
      };

      reader.readAsText(this.file);
    });
  }

  public getConfigFromTrackList(trackList):{[key: string]:{id: string, name: string, positions: any[], tool: any} }{
    let config = {};
    trackList.forEach((trk)=>{
      let segment = trk.querySelector('trkseg');
      let points = segment.querySelectorAll('trkpt');
      let trkName = this.fileName+'-'+trk.querySelector('name').textContent;
      if (!config.hasOwnProperty(trkName)){
        config[trkName] = {id: trkName, name:trk.querySelector('name').textContent,  positions: []};
      }
      config[trkName].tool = null;
      points.forEach((point)=>{
        config[trkName].positions.push({
          lat: point.getAttribute('lat'),
          lng: point.getAttribute('lon')
        });
      });
    });

    return config;
  }

  protected isAllowedType(){
    return this.type === 'gpx';
  }
}
